module.exports = __webpack_public_path__ + "static/media/EnrollmentIcon.bf989f11.svg";